import React, { FunctionComponent as FC, useMemo } from 'react';
import './index.scss';
import { figChart, figMorph, figStack, fig4p, verSVG, nexusSVG } from '../../common/nexusArt';
import posterUrl from '../../assets/7-material/NetSci2026-poster.pdf';
import { WAITING_LIST_URL } from '../WaitingListPage';

const PAPER_URL = 'https://arxiv.org/abs/2604.08491';

// The six concepts as small tiles in the "open artifact" window
const MINI: [string, string, () => string][] = [
  ['01 · Generate', '0 0 420 290', () => figChart()],
  ['02 · Export', '0 0 426 372', () => figMorph(2)],
  ['03 · F = {V, C, D, M}', '-30 0 500 360', () => figStack(true)],
  ['04 · Brush · Ask · Discover', '0 0 400 320', () => fig4p(3)],
  ['05 · Record', '40 4 850 400', () => verSVG(1)],
  ['06 · Nexus', '0 0 420 300', () => nexusSVG()],
];

interface EvaluationPageProps {
}

const EvaluationPage: FC<EvaluationPageProps> = () => {
  const minis = useMemo(() => MINI.map(([, , f]) => f()), []);

  return (
    <>
      {/* <section className='evalx contain' id='evaluation'>
        <div className='ehead'><h2>Tested on 308 tasks<br />and with 12 SciSci Experts</h2><p>A computational evaluation of the question-to-figure mapping, and a within-subjects study against Jupyter with Claude Code.</p></div>
        <div className='erow'>
          <div className='big'><b>92.7<small>%</small></b><p>end-to-end accuracy, from one question to the right chart</p></div>
          <div className='big'><b>91.0<small>%</small></b><p>of linked charts update correctly after a new selection</p></div>
          <div className='cmp2'><div className='l'>Nexus</div><div className='bar'><i style={{ width: '52%' }}></i><span>16.4 min</span></div><div className='l'>Jupyter + Claude Code</div><div className='bar'><i className='g' style={{ width: '100%' }}></i><span>31.4 min</span></div><p>the same analysis tasks in about half the time</p></div>
          <div className='cmp2'><div className='l'>Nexus</div><div className='bar'><i style={{ width: '100%' }}></i><span>89.4</span></div><div className='l'>Baseline</div><div className='bar'><i className='g' style={{ width: '72%' }}></i><span>64.8</span></div><p>System Usability Scale: excellent versus OK</p></div>
        </div>
      </section> */}

      <section className='open' id='artifact'><div className='contain in'>
        <div className='shot'><div className='mini' id='mini'>
          {MINI.map(([t, vb], i) => (
            <div key={t}><div className='t'>{t}</div><div className='mf'><svg viewBox={vb} preserveAspectRatio='xMidYMid meet' role='img' aria-label={t} dangerouslySetInnerHTML={{ __html: minis[i] }} /></div></div>
          ))}
        </div></div>
        <div>
          <h2>LLM-Native Figure</h2>
          <p>LLM-native figures redefine the role of the figure in science: no longer the end point of discovery, but a living interface through which humans and AI reason, explore and build knowledge together.</p>
          <div className='btns'><a className='btn' href={PAPER_URL} target='_blank' rel='noopener noreferrer'>Read the paper</a><a className='btn o' href={posterUrl} target='_blank' rel='noopener noreferrer'>Poster (PDF)</a><a className='btn o' href={WAITING_LIST_URL} target='_blank' rel='noopener noreferrer'>Try the prototype →</a></div>
        </div>
      </div></section>
    </>
  )
}

export default EvaluationPage;
